export default {
  getAnnouncements: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/announcements/getters.js